import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const CardListStyle = styled.div`
  ${props => {
    const {
      theme: { media = {} }
    } = props;
    return css`
      .container {
        display: grid;
        gap: 20px;
        max-width: unset;

        ${media.sm.up} {
          grid-template-columns: repeat(2, 1fr);
          gap: 40px;
        }

        ${media.md.up} {
          grid-template-columns: repeat(4, 1fr);
        }

        & > * {
          padding: 0 30px 20px 30px;
          border-bottom: 1px solid #ccc;

          ${media.sm.up} {
            padding: 0;
            border-bottom: none;
          }

          /* there's a gap between style-component & sass breakpoints */
          @media screen and (min-width: 600px) and (max-width: 640px) {
            padding-left: 30px;
            padding-right: 30px;
          }
        }
      }

      .card_image_container {
        position: relative;
        width: 100%;
        padding-top: 56.25%;
      }

      .card_image_container img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .footnote {
        padding-top: 6px;
      }

      .link-button {
        margin-top: 20px;
      }
    `;
  }};
`;

const CardList = ({ children }) => (
  <CardListStyle className="card-list">
    <div className="container">{children.map(child => child)}</div>
  </CardListStyle>
);

CardList.propTypes = {
  children: PropTypes.node.isRequired
};

export default CardList;
